export default "/images/aa8c9abe6246ae9cab73814e3858cebe.avif";